import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { RelatedProductsComponentDef } from '@df/catalog-ui/related-products/related-products.component.def';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { Gtm } from '@df/module-gtm/gtm.namespace';
import { GtmService } from '@df/module-gtm/gtm.service';
import { GtmTrackViewItemListDirective } from '@df/module-gtm/track/view-item-list/gtm-track-view-item-list.directive';
import { CarouselSlideDirective } from '@df/ui-carousel/carousel-slide.directive';
import { CarouselComponent } from '@df/ui-carousel/carousel.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ProductComponent } from '../product/product.component';

let uid = 0;

/**
 * Sample usage
 *
 * ```html
 *     <related-products class="block m-t m-b-8"
 *          [source]="model"
 *          [options]="{limit: [2,3,4,4][app.client.sizeId], engines: 'category'}">
 *              You may also like
 *     </related-products>
 * ```
 */
@Component({
    selector: 'related-products',
    templateUrl: './related-products.component.html',
    standalone: true,
    imports: [CommonModule, CarouselComponent, CarouselSlideDirective, GtmTrackViewItemListDirective, ProductComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RelatedProductsComponent extends RelatedProductsComponentDef implements OnInit {
    uid = `related-products-${uid++}`;

    @Input()
    listId = 'related-products';

    @Input()
    listName = 'Related Products';

    @Input()
    forbiddenProductIds?: number[];

    protected gtmService = inject(GtmService);

    get slidesPerView() {
        return [1.78, 2.53, 3.53, 3.53][this.client.sizeId];
    }

    get slidesPerViewRound() {
        return Math.round(this.slidesPerView);
    }

    get spaceBetween() {
        return [2, 4, 4, 4][this.client.sizeId];
    }

    get loop(): boolean {
        return (this.listing?.getTotal() || 0) > this.slidesPerViewRound;
    }

    get models(): Product<IProductDataV2>[] | undefined {
        if (this.forbiddenProductIds) {
            return this.listing?.models.filter(model => !this.forbiddenProductIds?.includes(model.id));
        }

        return this.listing?.models;
    }

    get gtmTrackViewItemList(): Gtm.ITrackViewItemList {
        return {
            listId: this.listId,
            listName: this.listName,
            models: this.listing?.models || []
        };
    }
}
